import { Theme, css } from '@emotion/react';

export const widgetFormRoot = ({ spacing }: Theme) => css`
  & > * {
    margin-top: ${spacing(1)};
    margin-bottom: ${spacing(1)};
  }
`;

export const widgetFormButtonContainer = ({ spacing }: Theme) => css`
  display: flex;
  gap: ${spacing(1.5)};
  margin-top: ${spacing(1)};
  margin-bottom: ${spacing(1)};
`;

export const widgetTypeSelect = ({ spacing }: Theme) => css`
  margin-left: ${spacing(0.5)};
  margin-top: ${spacing(1)};
  margin-bottom: ${spacing(1.5)};
`;
